<template>
  <Dialog :title="$t('OBS Restart Required')">
    <template #trigger><slot /></template>

    <p class="text-sm text-muted-foreground">
      To ensure that fonts and other added features load correctly, please
      restart OBS. We recommend restarting at this time.
    </p>

    <DialogFooter>
      <DialogClose variant="neutral" @click="$emit('cancel')">
        {{ $t("Restart Later") }}
      </DialogClose>

      <DialogClose variant="primary" @click="Bindings.win.restartOBS">
        {{ $t("Restart OBS") }}
      </DialogClose>
    </DialogFooter>
  </Dialog>
</template>

<script setup lang="ts">
import Bindings from '~/lib/bindings';

const emit = defineEmits(['cancel']);
</script>
